import React from 'react';
import {Container, Row, Col, Button} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import './styles.scss';
import '../HeroSection/styles.scss';

export const FinalCtaSection = () => {
    const navigate = useNavigate();

    // TODO: fix this
    const signupPageId: number = 5652854668787712;

    return (<section className="final-cta">
        <Container>
            <Row className="align-items-center">
                <Col md={8} className="final-cta__text">
                    <h2>Sign Up Now</h2>
                    <p>
                        Complete the Future Founders course to secure your chance to pitch your business idea at the Young Eyes Festival of
                        Innovation 2025.
                    </p>
                </Col>
                <Col md={4} className="text-md-right">
                    <div className="SignupSection--container">
                        <button className="SignupSection--button" onClick={() => navigate(`/join/public/${signupPageId}`)}><Trans>Signup for free</Trans></button>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
    );
};